import { css } from '@emotion/react';

export default $ => css`
  .array-item.for-object-row.denied,
  .array-item.panel-row.denied {
    background-color: ${$.white};
  }

  .array-item.for-object-row.superseded,
  .array-item.panel-row.superseded {
    background-color: ${$.gray100};
  }

  .uweentity-form.form-component:not(.hide-card-body) {
    background-color: ${$.white};
    border: ${$.cardBorderWidth} solid ${$.cardBorderColor};
    border-radius: 15px;
    box-shadow: 6px 3px 7px rgba(0, 0, 0, 0.1);
  }

  .uweentity-form.form-component.hide-card-body {
    .form-component-fields > .form-component {
      margin-right: 0;
      margin-left: 0;

      > .card {
        border: none;

        > .card-body {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }

  .uweentity-form.form-component {
    min-width: 0;
    margin-bottom: 50px;

    .card > .card-body {
      overflow-x: auto;
    }

    .card > .card-footer {
      border-top: none;
    }
  }

  .uweentity-form.form-component {
    > .uweentity-title {
      position: relative;
      background-color: ${$.primaryMain};
      color: ${$.white};
      font-size: 1.5rem;
      font-weight: bold;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      padding: 8px 18px;

      @media (max-width: 768px) {
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
      }

      > .btn-bar {
        position: absolute;
        right: 18px;
        top: 7px;

        > .btn {
          margin-left: 5px;
        }
      }

      > .cancel-btn {
        position: absolute;
        right: 18px;
      }
    }

    > .form-component,
    > .form-component-fields > .form-component {
      margin-left: 18px;
      margin-right: 18px;

      > .card {
        border: none;

        legend[id^='root_'][id$='__title'] {
          border-radius: 15px;
        }
      }
    }
  }

  .uweentity-form-full-expanded-sidepanel {
    border-bottom: 0px;
    border-left: 0px;
    border-right: 0px;
    padding: 7px;

    ul.striped-list {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

    ul.striped-list > li {
      border-bottom: 1px solid ${$.gray100};
      padding: 6px;
      padding-top: 15px;
      padding-bottom: 15px;
    }

    ul.striped-list > li:nth-of-type(odd) {
      background-color: ${$.gray200};
    }

    ul.striped-list > li:last-child {
      border-bottom: none;
    }

    .card-header {
      position: relative;
      font-size: 1.45rem;
      padding-top: 4px;
      font-weight: bold;
      padding-left: 9px;
      padding-bottom: 0;
    }

    .btn-bar {
      > .btn {
        position: relative;
        right: auto;
        top: auto;
        border-radius: 8px;
        width: 24px;
        min-width: auto;
        max-width: auto;
        padding: 0;
        height: 24px;
        margin-left: 12px;
        .fa {
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
`;
